module.exports = __webpack_public_path__ + "img/czytelnia.4a29c634.jpg";